export const getBannersList = state => state.banners.bannerList || [];
